(function () {
  'use strict';
  if (window.DaLucaCustomMasterV359) return;
  window.DaLucaCustomMasterV359 = true;

  function root() {
    return document.querySelector('.daluca-pdp--custom[data-daluca-custom-master], .daluca-pdp--custom[data-daluca-consolidated-custom="true"]');
  }

  function visibleBottom(node) {
    if (!node) return 0;
    var style = window.getComputedStyle(node);
    if (style.display === 'none' || style.visibility === 'hidden') return 0;
    var rect = node.getBoundingClientRect();
    return rect.height > 0 ? rect.bottom : 0;
  }

  function collapseHero() {
    var el = root();
    if (!el) return;

    if (window.innerWidth < 1068) {
      el.style.removeProperty('height');
      el.style.removeProperty('min-height');
      el.style.removeProperty('max-height');
      return;
    }

    var rootRect = el.getBoundingClientRect();
    var gallery = el.querySelector('.product-gallery-container');
    var thumbRail = el.querySelector('.product-gallery-container > scroll-shadow, .product-thumbnail-container');
    var details = el.querySelector('.daluca-custom-master-details');
    var sizing = el.querySelector('.daluca-sizing-guide-direct-v318, .daluca-sizing-guide-clean-v38');
    var specs = el.querySelector('.daluca-custom-master-specs');

    var bottoms = [
      visibleBottom(gallery),
      visibleBottom(thumbRail),
      visibleBottom(details),
      visibleBottom(sizing),
      visibleBottom(specs)
    ].filter(function (n) { return n > 0; });

    if (!bottoms.length) return;

    var targetBottom = Math.max.apply(Math, bottoms);
    var desired = Math.ceil(targetBottom - rootRect.top + 10);

    /* Guard against measuring during an uninitialized slider frame. */
    if (desired < 260 || desired > 1500) return;

    el.style.setProperty('height', desired + 'px', 'important');
    el.style.setProperty('min-height', '0', 'important');
    el.style.setProperty('max-height', desired + 'px', 'important');
    el.style.setProperty('overflow', 'visible', 'important');
  }

  function schedule() {
    collapseHero();
    [80, 180, 350, 700, 1200, 2200, 4000].forEach(function (delay) {
      window.setTimeout(collapseHero, delay);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', schedule, { once: true });
  } else {
    schedule();
  }

  window.addEventListener('load', schedule, { once: true });
  window.addEventListener('resize', function () {
    window.clearTimeout(window.__dalucaV359Resize);
    window.__dalucaV359Resize = window.setTimeout(collapseHero, 120);
  }, { passive: true });

  var el = root();
  if (el && 'ResizeObserver' in window) {
    var ro = new ResizeObserver(function () {
      window.clearTimeout(window.__dalucaV359RO);
      window.__dalucaV359RO = window.setTimeout(collapseHero, 40);
    });
    var gallery = el.querySelector('.product-gallery-container');
    var specs = el.querySelector('.daluca-custom-master-specs');
    if (gallery) ro.observe(gallery);
    if (specs) ro.observe(specs);
  }
})();
